import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { ActuatorInfo } from 'src/rdsap-api/model/actuatorInfo';

// Define the custom entity collection service
// This service is used to provide access to the RdSAPLookUpCodes data service
@Injectable({ providedIn: 'root' })
export class RdSAPInfoService extends EntityCollectionServiceBase<ActuatorInfo> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('RdSAPInfo', serviceElementsFactory);
  }
}
